export default "__VITE_PUBLIC_ASSET__e4167f72__"